import React, { useContext } from 'react';
import BackButton from '../BackButton';
import {
  ACTIVE_VIEW,
  AutomationsContex
} from '../engine/FormBuilderAutomationsEngine';
import { SimpleFlexContainer } from '../layouts/ng-layouts/Containers';
import { Container } from './FormBuilderStatusesView';
import styled from 'styled-components/macro';
import useTranslations from '../../hooks/useTranslations';
import _Select from '../engine/SelectEngine';
import _InputBase from '../form/InputBase';
import Button from '../Button';
import {
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Tooltip
} from '@material-ui/core';
import { getButtonStyle } from '../engine/CustomButtonWizardEngine';
import { FormBuilderContext } from '../engine/FormBuilderEngine';
import Labeler from '../Labeler';
import CharacterCounter from '../../internal-components/CharacterCounter';
import NoStatusesWarningDialog from '../../internal-components/GeneralDialog';
import WizardDirtyWarningDialog from '../../internal-components/GeneralDialog';
import BackspaceIcon from '@material-ui/icons/Backspace';
import CreateIcon from '@material-ui/icons/Create';
import DoneIcon from '@material-ui/icons/Done';
import ClearIcon from '@material-ui/icons/Clear';

const TitleContainer = styled.div`
  display: flex;
`;
const H2 = styled.h2``;

const LABEL_MAX_CHAR = 25;

const CONFIRMATION_MAX_CHAR = 500;

const DynamicTypeContainer = styled(SimpleFlexContainer)`
  margin-bottom: 2rem;
  align-items: center;
  & > button {
    margin-left: 0.8rem;
  }
`;

const OuterActionContainer = styled(SimpleFlexContainer)`
  margin-bottom: 2rem;
  align-items: center;
  & > button {
    margin-left: 0.8rem;
  }
  max-width: calc(100% - 46px) !important;
`;

const Select = styled(_Select)`
  max-width: 100% !important;
`;

const InputBase = styled(_InputBase)`
  max-width: calc(100% - 46px) !important;
`;

const ActionContainer = styled(SimpleFlexContainer)`
  flex: 2;
`;

const OptionContainer = styled(SimpleFlexContainer)`
  flex: 3;
`;

const SaveBtnPositioner = styled.div`
  align-self: end;
`;

const ConfirmationTextContainer = styled.div`
  margin-bottom: 1rem;
  position: relative;
`;

const ConfirmationTextContainerInner = styled.div`
  margin: 1rem 2rem 0 0;
`;

const EditConfirmationTextIconButton = styled(CreateIcon)`
  color: #4c84ff;
  cursor: pointer;
  bottom: 0;
  right: 0;
  position: absolute;
`;

const ConfirmationTextInputOuterContainer = styled(SimpleFlexContainer)``;

const ConfirmationTextInputContainer = styled.div`
  flex: 1;
`;

const CheckAndExContainer = styled.div`
  width: 100px;
`;

const CheckOrExIconButton = styled(IconButton)``;

const CheckIcon = styled(DoneIcon)`
  color: #61a52b;
`;

const ExIcon = styled(ClearIcon)`
  color: #df8e82;
`;

const BulkActionWizardView = props => {
  const { setActiveView } = useContext(AutomationsContex);
  const t = useTranslations();
  const { form } = useContext(FormBuilderContext);
  return (
    <>
      <Container>
        <SimpleFlexContainer>
          <TitleContainer>
            <BackButton onClick={props.onBackClicked} />
            <H2>{t('bulkActions.add.title')} </H2>
          </TitleContainer>
          <Labeler
            label={t('bulkActions.wizard.input.label.label')}
            customCSS="margin-bottom: 0.4rem;"
          >
            {/* add char limit */}
            <InputBase
              value={props.label}
              onChange={e =>
                props.dispatch({
                  type: 'update',
                  payload: { label: e.target.value }
                })
              }
              inputProps={{
                maxLength: LABEL_MAX_CHAR,
                'data-testid': 'bulkAction-label'
              }}
            />
            <CharacterCounter string={props.label} maxLength={LABEL_MAX_CHAR} />
          </Labeler>
          <Labeler label={t('bulkActions.wizard.select.status.label')}>
            <DynamicTypeContainer $row>
              <Select
                placeholder={t('bulkActions.wizard.select.status.placeholder')}
                value={props.statuses}
                options={[
                  {
                    text: t('bulkActions.wizard.select.status.all'),
                    value: 'all',
                    'data-testid': 'status-all'
                  },
                  ...(form.customStatuses || []).map(cs => ({
                    text: `Status: ${cs.label}`,
                    value: cs.internalId,
                    'data-testid': `status-${cs.internalId}`
                  }))
                ]}
                allowMultiSelect
                onChange={props.onStatusDDChange}
                customCSS="flex: 1; max-width: calc(50% - 0.4rem) !important;"
              />
              <Tooltip
                arrow
                title={t('bulkActions.wizard.select.status.select.clear')}
              >
                <IconButton
                  disabled={!props.statuses || !props.statuses.length}
                  size="small"
                  onClick={() => {
                    props.onStatusDDChange([]);
                  }}
                >
                  <BackspaceIcon />
                </IconButton>
              </Tooltip>
            </DynamicTypeContainer>
          </Labeler>
          <Labeler label={t('bulkActions.wizard.select.actions.label')}>
            <OuterActionContainer $row>
              <ActionContainer>
                <Select
                  value={'status'}
                  onChange={() => {}}
                  options={[
                    {
                      value: 'status',
                      text: t(
                        `bulkActions.wizard.select.action.option.changeStatus`
                      ),
                      'data-testid': 'change-status'
                    }
                  ]}
                  customCSS="max-width: calc(50% - 0.4rem) !important;"
                />
              </ActionContainer>
              <OptionContainer>
                <Select
                  customCSS="margin-left: 0.8rem !important;"
                  placeholder={t(
                    'bulkActions.wizard.actions.status.placeholder'
                  )}
                  value={props.updateValue}
                  onChange={value =>
                    props.dispatch({
                      type: 'update',
                      payload: { updateValue: value }
                    })
                  }
                  options={[
                    ...(form.customStatuses || []).map(cs => ({
                      text: `${cs.label}`,
                      value: cs.internalId,
                      'data-testid': `updateValue-${cs.internalId}`
                    }))
                  ]}
                />
              </OptionContainer>
            </OuterActionContainer>
          </Labeler>
          <Labeler label={t('bulkActions.wizard.input.confirmation.label')}>
            {props.confirmationEditMode ? (
              <ConfirmationTextInputOuterContainer $row>
                <ConfirmationTextInputContainer>
                  <InputBase
                    value={props.confirmationText}
                    onChange={e =>
                      props.dispatch({
                        type: 'update',
                        payload: { confirmationText: e.target.value }
                      })
                    }
                    multiline
                    rows={4}
                    inputProps={{
                      maxLength: CONFIRMATION_MAX_CHAR,
                      'data-testid': 'bulkAction-confirmationText'
                    }}
                  />
                  <CharacterCounter
                    string={props.confirmationText}
                    maxLength={CONFIRMATION_MAX_CHAR}
                  />
                </ConfirmationTextInputContainer>
                <CheckAndExContainer>
                  <CheckOrExIconButton
                    onClick={props.onClickSaveConfirmationText}
                    size="small"
                    data-testid="save-confirmationText"
                  >
                    <CheckIcon />
                  </CheckOrExIconButton>
                  <CheckOrExIconButton
                    onClick={props.onClickCancelConfirmationText}
                    size="small"
                    data-testid="cancel-confirmationText"
                  >
                    <ExIcon />
                  </CheckOrExIconButton>
                </CheckAndExContainer>
              </ConfirmationTextInputOuterContainer>
            ) : (
              <ConfirmationTextContainer>
                <ConfirmationTextContainerInner>
                  {props.confirmationText}
                </ConfirmationTextContainerInner>
                <EditConfirmationTextIconButton
                  onClick={props.onClickChangeConfirmationText}
                  size="small"
                >
                  <CreateIcon />
                </EditConfirmationTextIconButton>
              </ConfirmationTextContainer>
            )}
          </Labeler>
          <SaveBtnPositioner>
            <Tooltip arrow title={props.reasonsSaveIsDisabled}>
              <span>
                <Button
                  onClick={() => props.onSave()}
                  disabled={props.reasonsSaveIsDisabled}
                >
                  {t('bulkActions.wizard.save.btn')}
                </Button>
              </span>
            </Tooltip>
          </SaveBtnPositioner>
        </SimpleFlexContainer>
      </Container>
      <NoStatusesWarningDialog
        title="dialog.title.areYouSure"
        content="bulkActions.wizard.dialog.statuses.text"
        open={props.isNoStatusesDialogOpen}
        handleConfirm={() => {
          props.setIsNoStatusesDialogOpen(false);
          props.onSave(true);
          props.onWizardClosed();
        }}
        handleClose={() => props.setIsNoStatusesDialogOpen(false)}
      />
      <WizardDirtyWarningDialog
        title="dialog.title.areYouSure"
        content="bulkActions.wizard.dialog.dirty.text"
        open={props.isWizardDirtyDialogOpen}
        handleConfirm={() => {
          props.setIsWizardDirtyDialogOpen(false);
          props.onWizardClosed();
        }}
        handleClose={() => props.setIsWizardDirtyDialogOpen(false)}
      />
    </>
  );
};

export default BulkActionWizardView;
